import { useSearchParams } from 'react-router';
import type { HomeView } from '../api/home';

/**
 * `?view=first-run` shows Home's first-day states for any person, for design review. Development
 * builds only: `import.meta.env.DEV` is `false` in production, so the parameter does nothing.
 */
export function useHomeView(): HomeView {
  const [params] = useSearchParams();
  return import.meta.env.DEV && params.get('view') === 'first-run' ? 'first-run' : 'live';
}
